import { Component, OnInit } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { UntilDestroy, untilDestroyed } from '@ngneat/until-destroy';
import { ConfigurationService } from 'src/app/services/core/configuration/configuration.service';
import { DocumentService } from 'src/app/services/core/document/document.service';
@UntilDestroy()

@Component({
  selector: 'app-documents-list',
  templateUrl: './documents-list.component.html',
  styleUrls: ['./documents-list.component.css']
})
export class DocumentsListComponent implements OnInit {
  documents: any;
  
  constructor(
    private documentService: DocumentService) { }

  ngOnInit() {
    this.get();
  }


  get() {
    this.documentService.get().pipe(untilDestroyed(this)).subscribe((data) => {
      if (data) {
        this.documents = data;
      }
    })
  }

}